import { render, staticRenderFns } from "./PayInput.vue?vue&type=template&id=6b4bd89a&scoped=true"
import script from "./PayInput.vue?vue&type=script&lang=js"
export * from "./PayInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4bd89a",
  null
  
)

export default component.exports